/**
 * normalizarBusqueda — utilidades de búsqueda insensible a acentos para los
 * selectores del módulo Inventario.
 *
 * `normaliza` descompone con NFD y elimina los diacríticos combinantes
 * (\p{Diacritic}): así `María`→`maria`, `Muñoz`→`munoz` (la ñ se descompone en
 * n + tilde combinante) y `Girona`→`girona` con `ç`→`c` (cedilla combinante).
 * No hacen falta reemplazos especiales para ñ ni ç: caen solos con este paso.
 * Es deliberado que `ano` encuentre `año`: en un buscador de personas es el
 * trade-off correcto (alguien sin teclado español debe poder buscar).
 */
export function normaliza(s) {
  return String(s == null ? '' : s)
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase();
}

/**
 * ¿Coincide `texto` con `query`? Búsqueda por TOKENS con AND: cada palabra
 * (separada por espacios) debe aparecer en el texto, en cualquier orden. Ambos
 * lados se normalizan. Query vacía (o solo espacios) → true (no filtra).
 *   coincide('maria lopez', 'María López Pérez') === true
 */
export function coincideBusqueda(query, texto) {
  const tokens = normaliza(query).split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return true;
  const heno = normaliza(texto);
  return tokens.every((tk) => heno.includes(tk));
}

/**
 * Las opciones de un SearchableSelect ({ id, nombre, alias? }) que casan con `query`: por `nombre`
 * o, si la opción lo trae, por `alias` (cada uno por separado). El alias es otra forma de escribir lo
 * mismo que no se enseña: el literal del INE de un municipio («Pobla de Farnals, la» para «la Pobla
 * de Farnals»). Sin alias (personas, tipos…) es exactamente `coincideBusqueda(query, nombre)`.
 * Respeta el orden de `options`.
 */
export function filtrarOpciones(options, query) {
  const q = String(query == null ? '' : query).trim();
  if (!q) return options;
  return options.filter((o) => coincideBusqueda(q, o.nombre) || (o.alias != null && coincideBusqueda(q, o.alias)));
}
